/* eslint-disable no-use-before-define */
import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import {
    getPAFAA070detail,
    getPAFAA070detailbs,
    getPAJAB021,
    getPAJAC020CodeListPublic,
    getPAJAC020TaskManager,
} from '../../../services/Api';
import PopupSendMail from '../../../shared/components/PopupSendMail';
import RecruitPage from '../../../shared/components/RecruitPage';
import { BIZ_TYPE_OPTIONS } from '../../../shared/constants/app';
import { decodeToken, getCodeName } from '../../../utils';
import PAEAA060 from '../../Recruit/PAEAA010/popupPAEAA060';

const PAJAC051 = () => {
    const printRef = useRef();
    const { id } = useParams() || 'preview';
    const [data, setData] = useState({});
    const [popupData, setPopupData] = useState(null);
    const [location, setLocation] = useState({});
    const [recruitTime, setRecruitTime] = useState('');
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isPopupSendMailOpen, setIsPopupSendMailOpen] = useState(false);
    const dataPAJAC020 = useSelector(({ PAJAC020 }) => PAJAC020.data);
    const [receiver, setReceiver] = useState({ id: '', name: '' });
    const [companyType, setCompanyType] = useState('');
    const [searchParams] = useSearchParams();
    const bs = searchParams.get('bs');

    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);

    const codeLists = {
        A10: dataPAJAC020?.A10,
        A11: dataPAJAC020?.A11,
        A12: dataPAJAC020?.A12,
        A14: dataPAJAC020?.A14,
        A19: dataPAJAC020?.A19,
        A26: dataPAJAC020?.A26,
        A27: dataPAJAC020?.A27,
        A31: dataPAJAC020?.A31,
        A46: dataPAJAC020?.A46,
    };

    const fetchData = useCallback(async () => {
        if (id === 'preview') {
            await getPAJAB021().then(({ data }) => {
                setData({
                    ...data,
                    ...dataPAJAC020,
                    recruitClass: getCodeName(dataPAJAC020.recruitClass, 'A11', codeLists),
                    recruitForm: getCodeName(dataPAJAC020.recruitForm, 'A12', codeLists),
                    recruitLicense: getCodeName(dataPAJAC020.recruitLicense, 'A14', codeLists),
                    recruitDay: getCodeName(dataPAJAC020.recruitDay, 'A19', codeLists)[0],
                    needPaper: getCodeName(dataPAJAC020.needPaper, 'A46', codeLists).join(''),
                    assist1: getCodeName(dataPAJAC020.assist1, 'A31', codeLists),
                    assist2: getCodeName(dataPAJAC020.assist2, 'A31', codeLists),
                    assist3: getCodeName(dataPAJAC020.assist3, 'A31', codeLists),
                    assist4: getCodeName(dataPAJAC020.assist4, 'A31', codeLists),
                    assist5: getCodeName(dataPAJAC020.assist5, 'A31', codeLists),
                    companyName: data?.bizCompany,
                    nameKor: data?.nameKor,
                    homeUrl: data?.homepageUrl,
                    subBizImg: data?.subBizImg ? data.subBizImg.split('|') : null,
                    logoFile: data?.logoName,
                    companyType: data?.bizType,
                    compositionNum: data?.centerStaffCount,
                    compositionDesc: data?.memberDesc,
                    bizDesc: data?.centerDesc,
                    // subwayNum1: data?.subwayNum1,
                    // subwayNum2: data?.subwayNum2,
                    // subwayNum3: data?.subwayNum3,
                    // subwayPost1: data?.subwayPost1,
                    // subwayPost2: data?.subwayPost2,
                    // subwayPost3: data?.subwayPost3,
                    // mapStr: data?.mapStr,
                    // charge: data?.hrName,
                    // chargeEmail: data?.hrEmail,
                    // chargeTel: data?.hrPhone,
                    // chargeMobile: data?.hrMobilePhone,
                    // bizAddrDesc: data?.bizAddrDesc,
                });

                setRecruitTime(dataPAJAC020?.recruitTime || '');

                if (data?.companyType !== null && data?.bizType !== null) {
                    const bizType = BIZ_TYPE_OPTIONS?.find((item) => item.code === data?.bizType);
                    setCompanyType(bizType?.codeName || data?.bizType);
                }

                setLocation({
                    pointX: dataPAJAC020.pointX,
                    pointY: dataPAJAC020.pointY,
                });
            });
        } else {
            await getPAJAC020TaskManager().then((res) => (codeLists.A11 = res.data));
            await getPAJAC020CodeListPublic('A11,A12,A14,A46').then((res) => {
                const codeListData = res.data;
                codeLists.A11 = codeListData.A11;
                codeLists.A12 = codeListData.A12;
                codeLists.A14 = codeListData.A14;
                codeLists.A46 = codeListData.A46;
            });
            try {
                const response =
                    bs === null || bs === undefined ? await getPAFAA070detail(id) : await getPAFAA070detailbs(id, bs);

                const { data } = response;
                const newData = {
                    ...data,
                    recruitClass: getCodeName(data.recruitClass, 'A11', codeLists),
                    recruitForm: getCodeName(data.recruitForm, 'A12', codeLists),
                    recruitLicense: getCodeName(data.recruitLicense, 'A14', codeLists),
                    needPaper: getCodeName(data.needPaper, 'A46', codeLists),
                    subBizImg: data.subBizImg && data.subBizImg.length > 0 ? data.subBizImg : null,
                };
                setData(newData);
                setLocation({
                    pointX: data.pointX,
                    pointY: data.pointY,
                });
                setRecruitTime(data.recruitTime);
                if (data.companyType !== null || data.companyType !== '') {
                    const bizType = BIZ_TYPE_OPTIONS?.find((item) => item.code === data.companyType);

                    setCompanyType(bizType?.codeName);
                }
            } catch (error) {
                console.log(error);
            }
        }

        // eslint-disable-next-line
    }, [id]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const closePopup = () => {
        setIsPopupOpen(false);
        setPopupData(null);
        setIsPopupSendMailOpen(false);
    };

    const openPopup = () => {
        if (decode?.authorities === 'ROLE_P') {
            setPopupData((prev) => ({
                ...prev,
                ...data,
                recruitSeq: data.seq,
            }));
            setIsPopupOpen(true);
        } else if (decode?.authorities === 'ROLE_C') {
            window.alert('개인회원만 이용가능합니다.');
        } else {
            window.alert('로그인 후 이용가능합니다.');
        }
    };

    return (
        <>
            <div id="content">
                <div className="container">
                    <div id="job-detail" ref={printRef}>
                        {/* Top Detail */}
                        <div id="summary-job">
                            <div className="nav-job">
                                <h1 className="title">채용정보</h1>
                            </div>
                            <RecruitPage
                                data={data}
                                fetchData={fetchData}
                                decode={decode}
                                id={id}
                                setIsPopupSendMailOpen={setIsPopupSendMailOpen}
                                isPopupSendMailOpen={isPopupSendMailOpen}
                                printRef={printRef}
                                openPopup={openPopup}
                                setReceiver={setReceiver}
                                companyType={companyType}
                                recruitTime={recruitTime}
                                location={location}
                            />
                        </div>
                        {/* End Top Detail */}
                    </div>
                </div>
            </div>
            {isPopupOpen && <PAEAA060 popupData={popupData} closePopup={closePopup} />}
            {isPopupSendMailOpen && <PopupSendMail closePopup={closePopup} receiver={receiver} />}
        </>
    );
};

export default PAJAC051;
